(() => {
  const storageKey = 'icarus:appearance:v1';
  const root = document.documentElement;
  const allowedAppearances = new Set(['dark', 'light']);

  function currentAppearance() {
    return root.dataset.appearance === 'light' ? 'light' : 'dark';
  }

  function updateControls() {
    const appearance = currentAppearance();
    const nextAppearance = appearance === 'dark' ? 'light' : 'dark';

    document.querySelectorAll('[data-appearance-toggle]').forEach((control) => {
      control.setAttribute('aria-pressed', String(appearance === 'light'));
      control.setAttribute('aria-label', `Use ${nextAppearance} mode`);

      const label = control.querySelector('[data-appearance-toggle-label]');
      if (label) label.textContent = `${nextAppearance === 'light' ? 'Light' : 'Dark'} mode`;
    });
  }

  function applyAppearance(appearance, persist = true) {
    if (!allowedAppearances.has(appearance)) return;

    root.dataset.appearance = appearance;
    delete root.dataset.appearanceUnresolved;

    const themeColor = document.querySelector('[data-theme-color]');
    if (themeColor) themeColor.content = appearance === 'dark' ? '#0A0D12' : '#F7F9FB';

    if (persist) {
      try {
        window.localStorage.setItem(storageKey, appearance);
      } catch (error) {
        /* The selected appearance still applies for the current page. */
      }
    }

    updateControls();
    window.dispatchEvent(new CustomEvent('icarus:appearance-change', { detail: { appearance } }));
  }

  function closeChoiceDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  function initialiseAppearance() {
    const dialog = document.querySelector('[data-appearance-dialog]');

    if (root.dataset.appearanceUnresolved === 'true' && dialog) {
      dialog.addEventListener('cancel', (event) => event.preventDefault());

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    document.querySelectorAll('[data-appearance-choice]').forEach((control) => {
      control.addEventListener('click', (event) => {
        event.preventDefault();
        applyAppearance(control.dataset.appearanceChoice);
        closeChoiceDialog(dialog);
      });
    });

    document.querySelectorAll('[data-appearance-toggle]').forEach((control) => {
      control.addEventListener('click', () => {
        applyAppearance(currentAppearance() === 'dark' ? 'light' : 'dark');
      });
    });

    updateControls();
  }

  window.IcarusAppearance = {
    get: currentAppearance,
    set: applyAppearance,
    toggle: () => applyAppearance(currentAppearance() === 'dark' ? 'light' : 'dark'),
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAppearance, { once: true });
  } else {
    initialiseAppearance();
  }
})();
